import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from "react-redux";
import {
    NavBarLogo,
    NavBarShoppingCartIcon,
    NavbarSearchIcon,
    NavBarContentSearchItems,
    NavBarButton,
    LoginModal,
    LoginRegisterModal,
    MenuCategories, 
    DejanosMensajeModal,
    ProfieldModel,
    MobileMenu
} from "./index";
import { config, ROLES, DISPATCH_ID } from '../libs/utils/Const';
import { Modal } from './index';
import $ from "jquery";
import './navBar.css';
import { ApiClient } from "../libs/apiClient/ApiClient";
import moment from 'moment';
import ReactDOM from 'react-dom';
import './navbarlogo.css';

let modal = new Modal();
let apiClient = ApiClient.getInstance();

class NavBar extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            marcas: [],
            aparatos: [],
            refacciones: [],
            fabricantes: [],
            materiales: [],
            seller: JSON.parse(localStorage.getItem(config.general.localStorageNamed + 'PartnerUser')),
            vendor: JSON.parse(localStorage.getItem(config.general.localStorageNamed + 'vendor')),
            user: JSON.parse(localStorage.getItem(config.general.localStorageNamed + 'CurrentUser')),
        };
      }
    //Evento para capturar los valores de los campos
    handelChange = ({ target }) => {
        const { name, value } = target;
        this.setState({
            [name]: value
        });
    };

    componentDidMount() {
        // this.fillDataSearch();
    }

    toggleMenuUser = () => {
        $("#menu-user-button").click(function () {
            $(".menu-user").toggle();
            $(".menu-user-responsive").focus();
        });
    }

    renderName = () => {
        const { configReducer, sessionReducer: { user } } = this.props;
        const { seller, vendor } = this.state;
        ////console.log("se puede mostar", empID);
        // //console.log("in vendor", vendor);
        if (seller !== null && seller.U_FMB_Handel_Perfil != '0') {
            return (
                <span className="ml-2" style={{ color: config.navBar.textColor }}>{seller.firstName || seller.FirstName} {seller.lastName || seller.LastName}{':'} {user.CardName}</span>
            );
        } else {
            return (
                <span className="ml-2" style={{ color: config.navBar.textColor }}>{user.CardName}</span>
            );
        }
    }

    iconUser = (priceList)=>{
        let result = '';
        switch (priceList) {
            // case 4:
            //     result = config.Avatar.bronze1;
            //     break;
            // case 5:
            //     result = config.Avatar.silver1;
            //     break;
            // case 6:
            //     result = config.Avatar.gold1;
            //     break;
            // case 7:
            //     result = config.Avatar.platinum1;
            //     break;
            // case 9:
            //     result = config.Avatar.diamond1;
            //     break;
            // case 13:
            //     result = config.Avatar.mercado1;
            //     break;
            default:
                result = config.Avatar.red1;
                break;
        }
        return result
    }

    nivel = (priceList)=>{
        let result = '';
        switch (priceList) {
            case 4:
                result = 'Bronze';
                break;
            case 5:
                result = 'Silver';
                break;
            case 6:
                result = 'Gold';
                break;
            case 7:
                result = 'Platinum';
                break;
            case 9:
                result = 'Diamond';
                break;
            case 13:
                result = 'Filial';
                break;
            default:
                result = '';
                break;
        }
        return result
    }

    renderClientOptionFirstNavBar = () => {
        const { configReducer, sessionReducer: { user } } = this.props;
        const { seller } = this.state;
        return (
            <ul className="navbar-nav miCuenta d-md-flex ml-4" style={{maxWidth: 600}}>
                <li className="nav-item">
                    <span className="imgAvatar row">
                            {/* <i id="IconUser" className={config.icons.user} aria-hidden="true" style={{ color: config.navBar.iconColor2, fontSize: 25 }} /> */}
                            {/* <img src={this.iconUser(user.listNum)} style={{ color: config.navBar.iconColor2}}/> */}
                            
                            <h4 type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                {/* <span className="ml-2" style={{widh:150, maxWidth: 200, color: "#0078C0"}}><strong>Bienvenido </strong><br/>{user.CardName}</span> */}
                                {/* <div className="marq" ><span className="orig">{this.renderName()}</span></div><br/> */}
                                
                                {/* <div> */}
                                    <i class="fa fa-user " aria-hidden="true" style={{ fontSize:"25px", color:"black", marginTop:"5px", marginLeft:".5rem", marginRight:".5rem"}}></i>
                                    {/* <span>Mi cuenta</span> */}
                                {/* </div> */}
                                {/* <label className="justify-content-left" ><span className="text-left font-weight-bold">Nivel: {this.nivel(user.listNum)}</span></label> */}
                            </h4>
                            {/* <div className="dropdown"> */}
                            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton" style={{top:"-70px !important"}} >
                            {/* {seller ? seller.U_FMB_Handel_Perfil != '0' && seller.U_FMB_Handel_Perfil != 5 ? 
                                <a className="dropdown-item m-item " style={{ color: config.navBar.textColor2 }} onClick={() => { configReducer.history.goSelectClient(); }}>Mis clientes</a>
                                : "" : ""
                            } */}
                            {/* {seller ? seller.U_FMB_Handel_Perfil != '0' && seller.U_FMB_Handel_Perfil != 5 ? 
                                <a className="dropdown-item m-item" style={{ color: config.navBar.textColor2 }} onClick={() => { configReducer.history.goBoletin(); }}>Ver correos del boletín</a>
                                : "" : ""
                            } */}
                            {/* {seller ? seller.U_FMB_Handel_Perfil != '0' && seller.U_FMB_Handel_Perfil != 5 ? 
                                <a className="dropdown-item" onClick={() => { configReducer.history.goAnalytics(); }}>Analytics</a>
                                : "" : ""
                            } */}
                            {/* {seller ? seller.U_FMB_Handel_Perfil != '0' && seller.U_FMB_Handel_Perfil != 5 && seller.U_FMB_Bonificaciones === "1" ?
                                <a className="dropdown-item m-item" style={{ color: config.navBar.textColor2 }} onClick={() => { configReducer.history.goPromocionales(); }}>Bonificaciones</a>
                                : "" : ""
                            } */}
                            {/* {Object.entries(user).length !== 0 && } */}
                            {/* {config.modules.subirArchivoExcel && seller ? seller.U_FMB_Handel_Perfil != 5 && Object.entries(user).length !== 0 ? 
                                <Link to='/subirArchivo'  className="dropdown-item m-item dropdown-menu-href" >Subir archivo OC</Link>
                                : "" : ""
                            } */}
                            {/* {seller ? seller.U_FMB_Handel_Perfil != 5 && Object.entries(user).length !== 0 ?
                                <Link to='/reports' className="dropdown-item m-item dropdown-menu-href" >Mis reportes</Link>
                                : "" : ""
                            } */}
                            {/* <a className="dropdown-item" onClick={() => { configReducer.history.goOrders(); }}>Mis pedidos</a> */}
                            {/* {user.wishlist === 1 &&
                                <a className="dropdown-item m-item" style={{ color: config.navBar.textColor2 }} onClick={() => { configReducer.history.goBackOrder(); }}>Lista de deseos</a>} */}
                            {/* {user.U_FMB_Handel_Admin === '1' &&
                                <a className="dropdown-item" onClick={() => { configReducer.history.goML(); }}>Admin ML</a>} */}
                            {/* {user.banners === "on" && */}
                            {/* {user ? user.U_FMB_Handel_Admin == 1 ?
                                <Link to='/adminBanners'  className=" dropdown-item m-item dropdown-menu-href" >Adm. Banners</Link>
                                : "" : ""
                            } */}
                            {/* seller ? seller.U_FMB_AdmBlogNoticia == 1 ? */}
                            {/* {seller ? seller.U_FMB_AdmBlogNoticia == 1 ?
                                <Link to='/admiNewsBlog'  className="dropdown-item m-item dropdown-menu-href" >Adm. Blog de noticias</Link>
                                : "" : ""
                            } */}
                            {/* {seller ? seller.U_FMB_Handel_Perfil === 5
                                    ? 
                                    <a className="dropdown-item m-item" style={{ color: config.navBar.textColor2 }} onClick={() => { configReducer.history.goAutorizaciones(); }}>Autorizaciones</a>
                                    : "" : ""
                                } */}
                                {/* goMyProfile es el perfil de Pete, goProfile es de Missa */}
                            {seller ? seller.U_FMB_Handel_Perfil != 5 && Object.entries(user).length !== 0 ?
                                <a className="dropdown-item m-item" style={{ color: config.navBar.textColor2 }} onClick={() => { configReducer.history.goProfile(); }}>Mi Perfil</a>
                                : "" : ""
                            }
                                {/* <Link to='/reports' className="dropdown-item"  style={{ color: config.navBar.textColor }}>Mis reportes</Link> */}
                            {/* {user.banners === "on" &&
                                <Link to='/adminBanners' style={{ color: config.navBar.textColor2 }} className="dropdown-item m-item dropdown-menu-href">Adm. Banners</Link>
                            } */}
                            {/* {user.U_FMB_Handel_Admin === '1' && config.modules.points &&
                                <a className="dropdown-item m-item" style={{ color: config.navBar.textColor2 }} onClick={() => { configReducer.history.goResetPoints(); }}>Periodo de puntos</a>} */}
                            {/* {user.U_FMB_Handel_Admin === '1' &&
                                <a className="dropdown-item m-item" style={{ color: config.navBar.textColor2 }} onClick={() => { configReducer.history.goSpecialPrices(); }}>Precios especiales</a>} */}

                                {/* <a className="dropdown-item" onClick={() => { configReducer.history.goProfile(); }}>Mi Perfil</a> */}
                            <a className="dropdown-item m-item" style={{ color: config.navBar.textColor2 }} onClick={() => { this.logOut(); }}>Cerrar Sesión</a>
                        </div>
                        </span>
                    {/* </div> */}
                </li>
            </ul>
        )
    };

    /* DropMenu - Categorias */
    renderCategoriasNavBar = () => {
        const { configReducer, sessionReducer: { user } } = this.props;
        const { seller } = this.state;
        return (
            <ul className="navbar-nav miCuenta d-md-flex ml-4" style={{maxWidth: 600}}>
                <li className="nav-item">
                    <span className="imgAvatar row" style={{paddingTop:"12px"}}>
                        {/* <i id="IconUser" className={config.icons.user} aria-hidden="true" style={{ color: config.navBar.iconColor2, fontSize: 25 }} /> */}
                            <img src={this.iconUser(user.listNum)} style={{ color: config.navBar.iconColor2}}/>
                        <a className="nav-link dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            {/* <span className="ml-2" style={{widh:150, maxWidth: 200, color: "#0078C0"}}><strong>Bienvenido </strong><br/>{user.CardName}</span> */}
                            <div className="marq" ><span className="orig">{this.renderName()}</span></div><br/>
                            {/* <label className="justify-content-left" ><span className="text-left font-weight-bold">Nivel: {this.nivel(user.listNum)}</span></label> */}
                        </a>
                    {/* <div className="dropdown"> */}
                        <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                            {seller ? seller.U_FMB_Handel_Perfil != '0' && seller.U_FMB_Handel_Perfil != 5 ? 
                                <a className="dropdown-item" onClick={() => { configReducer.history.goSelectClient(); }}>Categoria 1</a>
                                : "" : ""
                            }
                        </div>
                    </span>
                    {/* </div> */}
                </li>
            </ul>
        )
    };
    // Fin DropMenu Categorias

    logOut = async () => {
        const { configReducer, setItemsAutoComplete, setBusiness, setToken, setUser, setRememberUser, setRole, shoppingCartReducer: { getShoppingCart }, sessionReducer: { user } } = this.props;
        const { seller, vendor } = this.state;
        ////console.log('logout');
        // ---------------------------------------------------------------------------------------------
        let today = moment().format('YYYY-MM-DD');
        let time = moment().format('h:mm:ss a');
        let data = [];
        // Funcion AutoComplete al cerrar sesión
        let suggestions = [];
        let apiResponse = await apiClient.AutoComplete();
        

        if(seller && seller.U_FMB_Handel_Perfil == 2 ){
            data = {
                CardCode : seller.salesPrson,
                CardName : seller.lastName + ' ' + seller.firstName,
                Date : today, 
                Time : time,
                TypeUser : 'Vendedor',
                Email : seller.email,
                IP : '192.168.0.139', 
                Business : 'Irco',
                Session : 0
            }
        }else if(seller.U_FMB_Handel_Perfil == 0){
            data = {
                CardCode : user.CardCode,
                CardName : user.CardName,
                Date : today, 
                Time : time,
                TypeUser : 'Cliente',
                Email : user.U_FMB_Handel_Email,
                Business : 'Irco',
                Session : 0
            }
        }
        if( Object.keys(data).length > 0){
            await apiClient.sendData(data);
        }
        
       
        // ---------------------------------------------------------------------------------------------
        localStorage.removeItem(config.general.localStorageNamed + 'Role');
        localStorage.removeItem(config.general.localStorageNamed + 'Token');
        localStorage.removeItem(config.general.localStorageNamed + 'CurrentUser');
        localStorage.removeItem(config.general.localStorageNamed + 'PartnerUser');
        localStorage.removeItem(config.general.localStorageNamed + 'RememberUser');
        localStorage.removeItem(config.general.localStorageNamed + 'vendor');
        localStorage.clear();
        configReducer.history.goHome();

        setRole(ROLES.PUBLIC);
        setBusiness(config.general.business);
        setToken(undefined);
        setUser({});
        setRememberUser(false);

        // COnsulta de AutoComplete al cerrar sesión
        suggestions = apiResponse.data.data;
        setItemsAutoComplete(suggestions);

        setTimeout(async () => {
            await getShoppingCart(true);
        }, 300);
        window.location.reload()
    };

    renderPublicOptionFirstNavBar = () => {
        const { configReducer: {history} } = this.props;
        return (
            <ul className="navbar-nav d-none d-md-flex">
                <li className="nav-item" >
                    <a className="nav-link" style={{ color: config.navBar.textColor }}>
                        <h4 className = "font-weigth-bold mr-sm-2 miCuenta" style={{ color: '#000000',fontWeight:"300", fontFamily:"Montserrat"}} onClick={() => { /*modal.loginModal('show')*/ history.goLogin(); }}>
                            {/* <img src={config.navBar.avatar} alt="avatar" style={{width: "28px"}} /> */}
                            <i class="fa fa-user" aria-hidden="true" style={{ fontSize:"25px", color:"black", marginTop:"0px", marginLeft:".5rem", marginRight:".5rem"}}></i> 
                            Inicio de sesión
                        </h4>
                    </a>
                </li>
                {/* <li className="nav-item">
                    <a className="nav-link" style={{ color: config.navBar.textColor }}>
                        <span onClick={() => { modal.loginRegisterModal('show') }}>Registrarse</span>
                    </a>
                </li> */}
            </ul>
        )
    };
    getCurrentUser(){  
        let currenuser = {}
        if(localStorage.getItem(config.localStorageNamed + 'CurrentUser') !== null){
            currenuser={
                contactPerson : JSON.parse(localStorage.getItem(config.localStorageNamed + 'CurrentUser')).contactPerson.name,
                user : JSON.parse(localStorage.getItem(config.localStorageNamed + 'CurrentUser')).CardName
            }
        }
        return currenuser;               
    }
/* Configuracion del primer navar- tel/whats/ubicacion */
    renderFirstNavBar = () => {
        const { sessionReducer, configReducer } = this.props;        
        const User = this.getCurrentUser().user;
        const contactPerson = this.getCurrentUser().contactPerson; 
        
        return (
            <div style={{zIndex: 10}}>
                <div className="row justify-content" style={{fontSize: '13px', justifyContent:"flex-end", marginRight:"-6px"}}>
                    {/* <div className="col-auto">
                        <a href= {config.footer.info.linkPhoneWhats} target="_blank">
                            <img className="img-fluid" width='25px' src={config.BarraTelefono.Whats} style={{ color: config.footer.iconColor, padding: 1 }}></img>&nbsp;
                            <span style={{color:"white"}}>{config.footer.info.phoneWhats}</span>
                        </a>
                    </div> */}
                    {/* <div className="col-auto">
                        <a>
                            <img className="img-fluid" width='25px' src={config.BarraTelefono.IconCel} style={{ color: config.footer.iconColor, padding: 1 }}></img>&nbsp;
                            <span style={{color:"white"}}>{config.footer.info.phone}</span>
                        </a>
                    </div> */}
                    {/* <div className="col-auto">
                        <a onClick={() => { configReducer.history.goSucursales(); }} target="_blank">
                            <img className="img-fluid" width='25px' src={config.BarraTelefono.IconUbicacion} style={{ color: config.footer.iconColor, padding: 1 }}></img>&nbsp;
                            <span style={{color:"white"}}>Una sucursal cerca de ti</span>
                        </a>
                    </div> */}
                </div>
                {/* Configuracion de hamburguer */}
                <nav id="navFirst" className="​navbar navbar-expand-sm primerNav" style={{ border: "none", background: config.navBar.backgroundColor }} >
                    <ul className="navbar-nav elements">
                        <li className="nav-link menu-categories-button text-center" style={{ color: config.navBar.textColor, cursor: "auto" }}>
                            <div class="d-inline">
                            <img className='shopp1 d-none d-sm-inline d-lg-none' src={config.navBar.menu} style={{ width: "35px", cursor: "pointer" }} data-target='#offCanvasCategories' onClick={''} data-toggle='modal' />
                            <img className='shopp2 pr-3 d-sm-none' src={config.navBar.menu} style={{ width: "35px", cursor: "pointer" }} data-target='#offCanvasCategories' onClick={''} data-toggle='modal' />
                            </div>
                            {config.modules.hamburgesaCategorias === true &&
                                <img id="buttonMenu" src={config.navBar.menu} className="Img-fluid" style={{ color: config.navBar.iconColorNavBar }} />
                            }
                            {config.modules.hamburger && <><img  className="Img-fluid" style={{ color: config.navBar.iconColor, cursor:'pointer'}} />
                            <MobileMenu /></>
                            }

                        </li>
                        <li>
                            <div className="navbar-brand">
                                <NavBarLogo />
                            </div>
                        </li>                     
                        <li className="nav-item searchItems d-md-block d-none" style={{ textAlign: "-webkit-center"}}>
                            <NavBarContentSearchItems className="nav justify-content-center" icon={config.icons.search} iconColor={config.navBar.iconColor} textColor={config.navBar.backgroundColor} fillDataSearch ={this.fillDataSearch} />

                        </li>
                        {/* <li className="nav-item text-center d-md-none d-lg-none searchAdvance" > 
                            <span className="buttonSearchAdvanced" > <img src={config.navBar.iconSearch} onClick={() => this.fillDataSearch()} className="Img-fluid"/> </span> 
                            <span className="d-md-none" ><img src={config.navBar.searchAdvanced} className="Img-fluid" onClick={() => { modal.searchModal('show') }}/></span>
                        </li> */}
                        <li className="shopp nav-item mr-sm-auto d-md-flex row" id="navbarFirst" style={{marginRight: "5px", paddingTop:"0px"}}>  
                            <div style={{paddingTop:'8px'}}>
                                { contactPerson || User || ''}                                
                            </div>  
                            <span >
                                <span>{sessionReducer.role === ROLES.PUBLIC ? this.renderPublicOptionFirstNavBar() : this.renderClientOptionFirstNavBar()}</span>
                            </span>
                            <span className="ml-2">
                                <NavbarSearchIcon
                                    icon={config.icons.search}
                                    iconColor={/*config.navBar.iconColor*/ "#1a1c1e"}
                                    textColor={config.navBar.textColor}
                                />
                                <NavBarShoppingCartIcon
                                    icon={config.icons.shoppingCart}
                                    iconColor={config.navBar.iconColor2}
                                    textColor={config.navBar.textColor}
                                />
                            </span>                         
                        </li>
                     </ul>
                </nav>
                {/* <div className="fixed-top navbar navbar-expand-sm navbar-dark" style={{ border: 'none', padding: 0, height: 45, background: config.navBar.backgroundColor, marginTop: 30 }}>
                    <ul className="navbar-nav " style={{ paddingLeft: 16, paddingBottom: 16 }}>
                        <li className="nav-link menu-categories-button" style={{ color: config.navBar.textColor, cursor: "pointer" }}>
                            <i className={config.icons.menu} style={{ color: config.navBar.iconColor, fontsize: 15 }} />
                        </li>
                    </ul>
                    <NavBarLogo />
                    <ul className="navbar-nav  col-md-4 d-sm-block d-none  " style={{ paddingBottom: 5, marginLeft: 230, textAlign: "center" }}>
                        <li>
                            <NavBarContentSearchItems className="nav justify-content-center" icon={config.icons.search} iconColor={config.navBar.iconColor} textColor={config.navBar.backgroundColor} />
                        </li>
                    </ul>
                    <div className="row" >
                        <div className="col-md-12">
                            <button type="button"
                                className="btn btn-primary btn-sm btn-block"
                                style={{ fontsize: 25, background: config.navBar.iconColor, color: "white" }}
                                onClick={() => { modal.searchModal('show') }}>
                                Busqueda avanzada
                            </button>
                        </div>
                    </div>
                    <div className="navbar-nav ml-sm-auto d-md-flex" id="navbarFirst">
                        <span className="mr-2 p-1">
                            <span>{sessionReducer.role === ROLES.PUBLIC ? this.renderPublicOptionFirstNavBar() : this.renderClientOptionFirstNavBar()}</span>
                        </span>
                        <span className="p-1 mr-3">
                            <NavbarSearchIcon
                                icon={config.icons.search}
                                iconColor={config.navBar.iconColor}
                                textColor={config.navBar.textColor}
                            />&nbsp;
                        <NavBarShoppingCartIcon
                                icon={config.icons.shoppingCart}
                                iconColor={config.navBar.iconColor}
                                textColor={config.navBar.textColor}
                            />
                        </span>
                    </div>
                </div> */}
            </div >
        );
    };

    renderPublicOptionMenu = () => {
        const { configReducer: {history} } = this.props;
        return (
            <ul className="navbar-nav mr-auto" >
                <li className="nav-item" >
                    <a className="nav-link" style={{ color: config.navBar.textColor }}>
                        <h4 className = "font-weigth-bold" style={{ color: config.navBar.textColor2 }} onClick={() => { /*modal.loginModal('show')*/ history.goLogin(); }}><i className="fas fa-user-circle"/> Inicio de sesión </h4>
                    </a>
                </li>
            </ul>
        )
    };

    searchModal = () => {
        const { marcas, aparatos, refacciones, fabricantes, materiales } = this.state;
        ////console.log('Valor del state', this.state);
        return (
            <div className="modal fade" id="searchModal" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" style={{ border: "none", textAlign: "center" }}>
                <div className="modal-dialog" role="document" style={{ margin: "1.75rem auto" }}>
                    <div className="modal-content">
                        <div className="modal-header" style={{ background: '#0060aa'  }}>
                            <h5 className="modal-title " style={{ color: config.navBar.textColor2 }}>Búsqueda</h5>
                            <button type="button" style={{ color: config.navBar.textColor2 }} className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body bg3">
                            <form onSubmit={this.handelSubmit} method="post" encType="text/plain" className="container">
                                <div className="row">
                                    <div className="col-md-12">
                                        <h4>Marca</h4>
                                        <select name="marca" placeholder="Selecciona una marca" className="form-control text-left" onChange={this.handelChange} style={{ textAlign: "center", height: 30, padding: 0 }}>
                                            <option value="">Selecciona una marca</option>
                                            {marcas &&
                                                marcas.map(marca => {
                                                    return <option value={marca.Code} key={marca.Code}>{marca.Name}</option>
                                                })
                                            }
                                        </select>
                                    </div>
                                    <div className="col-md-12">
                                        <h4>Aparato</h4>
                                        <select name="aparato" placeholder="Selecciona un aparato" className="form-control text-left" onChange={this.handelChange} style={{ textAlign: "center", height: 30, padding: 0 }}>
                                            <option value="">Selecciona un aparato</option>
                                            {aparatos &&
                                                aparatos.map(aparato => {
                                                    return <option value={aparato.Code} key={aparato.Code}>{aparato.Name}</option>
                                                })
                                            }
                                        </select>
                                    </div>
                                    <div className="col-md-12">
                                        <h4>Refacción</h4>
                                        <select name="refaccion" placeholder="Selecciona una refaccion" className="form-control text-left" onChange={this.handelChange} style={{ textAlign: "center", height: 30, padding: 0 }}>
                                            <option value="">Selecciona una refacción</option>
                                            {refacciones &&
                                                refacciones.map(refaccion => {
                                                    return <option value={refaccion.Code} key={refaccion.Code}>{refaccion.Name}</option>
                                                })
                                            }
                                        </select>
                                    </div>
                                    {/* <div className="col-md-12">
                                        <h4>Fabricante</h4>
                                        <select name="fabricante" placeholder="Selecciona un fabricante" className="form-control text-left" onChange={this.handelChange} style={{ textAlign: "center", height: 30, padding: 0 }}>
                                            <option value="">Selecciona un fabricante</option>
                                            {fabricantes &&
                                                fabricantes.map(fabricante => {
                                                    return <option value={fabricante.Code} key={fabricante.Code}>{fabricante.Name}</option>
                                                })
                                            }
                                        </select>
                                    </div> */}
                                    <div className="col-md-12">
                                        <h4>Material</h4>
                                        <select name="material" placeholder="Selecciona un material" className="form-control text-left" onChange={this.handelChange} style={{ textAlign: "center", height: 30, padding: 0 }}>
                                            <option value="">Selecciona un material</option>
                                            {materiales &&
                                                materiales.map(material => {
                                                    return <option value={material.Code} key={material.Code}>{material.Name}</option>
                                                })
                                            }
                                        </select>
                                    </div>
                                    {/* <div className="col-md-12">
                                        <h4>Nombre</h4>
                                        <input type="text" className="form-control" placeholder="Nombre(s)" name="nombre" onChange={this.handelChange} />
                                    </div> */}
                                    <div className="row">
                                        <div className="form-group col-md-12">
                                            <input type="submit" value="Buscar" className="btn mb-2 btn-block "
                                                style={{ fontsize: 25, background: '#0060aa' , color: "white", marginTop: 15 }} />
                                        </div>
                                    </div> 
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        )
    };

    fillDataSearch = async () => {
        const { enableSpinner } = this.props;
        //Busqueda de valores para los desplegables
        enableSpinner(true);
        await apiClient.getFiltros().then(result => {
            this.setState({
                marcas: result.data.marcas || [],
                aparatos: result.data.aparatos || [],
                refacciones: result.data.refacciones || [],
                fabricantes: result.data.fabricantes || [],
                materiales: result.data.materiales || [],
            });
            setTimeout(() => {
                modal.searchModal('show');
            }, 300);
           
        });
        enableSpinner(false);
        
    };

    handelSubmit = async (e) => {
        //Prevenimos un recargo de pagina
        e.preventDefault();
        //Definimos las variables que estan en el state
        const { marca, marcas, aparato, refaccion, fabricante, material, nombre } = this.state;
        const { enableSpinner, setItemsSearch, configReducer: { history }, setItemsFilterSearch,sessionReducer } = this.props;
        //Validamos que los campos esten llenos

        //Preparamos los datos para pasarlos al back
        let busqueda = {
            contenido: {
                marca: marca,
                aparato: aparato,
                refaccion: refaccion,
                fabricante: fabricante,
                material : material,
                nombre: nombre,
            }
        };
        //Hace la petición al back
        enableSpinner(true);
        // console.log("EGO =>",busqueda);
        await apiClient.searchAdvance(busqueda).then(result => {
            // console.log("EGO =>",result);
            modal.searchModal('hide');
            enableSpinner(false);
            setItemsSearch(result.data);
            setItemsFilterSearch(result.data);
            // -----------------------------------
            let today = moment().format('YYYY-MM-DD');
            let time = moment().format('h:mm:ss a');
            let data = {
                cve_user : sessionReducer.user.CardCode || '',
                search :  marca+' '+aparato+' '+refaccion+' '+fabricante+' '+material+' '+nombre,
                date : today,
                time : time,
                origin : 'busqueda',
                num_results : result.data.length,
            }
            // await apiClient.Search(data);
            // -----------------------------------
            history.goItems();
            return;
        });
        //Validamos la respuesta del Back
    };

    renderClientOptionMenu = () => {
        const { configReducer, sessionReducer: { user } } = this.props;
        const { seller } = this.state;
        ////console.log(user);
        return (
            <ul className="navbar-nav mr-auto">
                {/* <li className="nav-item">
                    <a className="nav-link" style={{ color: config.navBar.textColor }}>
                        <i className={config.icons.user} style={{ color: config.navBar.iconColor }} aria-hidden="true" />
                        <strong><span style={{color: config.navBar.textColor2}}>{user.CardName}</span></strong>
                    </a>
                </li> */}
                {/* <li className="nav-item" onClick={() => { configReducer.history.goProfile(); }}>
                    <a className="nav-link" style={{ color: config.navBar.textColor }}>
                        <strong><span style={{color: config.navBar.textColor2}}>{user.CardName}</span></strong>
                    </a>
                </li> */}
                {/* <li className="nav-item" onClick={() => { configReducer.history.goProfile(); }}>
                    <a className="nav-link" style={{ color: config.navBar.textColor }}>
                        <span style={{color: config.navBar.textColor2}}>Nivel: {this.nivel(user.listNum)}</span>
                    </a>
                </li> 
                dropdown-menu-item
                */}
                
                <li className="nav-item" onClick={() => { configReducer.history.goProfile(); }}>
                    <a className="nav-link" style={{ color: config.navBar.textColor }}>
                        <span  className="dropdown-item dropdown-menu-item" style={{color: config.navBar.textColor2}}>Mi Perfil</span>
                    </a>
                </li>
                {/* {seller ? seller.U_FMB_Handel_Perfil != '0' && seller.U_FMB_Handel_Perfil != 5 ? 
                    <li className="nav-item" onClick={() => { configReducer.history.goSelectClient(); }}>
                        <a className="nav-link dropdown-menu-item" style={{ color: config.navBar.textColor }}>
                            <span className="dropdown-item dropdown-menu-item" style={{color: config.navBar.textColor2}}>Mis clientes</span>
                        </a>
                    </li>
                    : "" : ""
                } */}

                {/* {seller ? seller.U_FMB_Handel_Perfil != '0' && seller.U_FMB_Handel_Perfil != 5 ? 
                    <li className="nav-item" onClick={() => { configReducer.history.goAnalytics(); }}>
                        <a className="nav-link" style={{ color: config.navBar.textColor }}>
                            <span  style={{color: config.navBar.textColor2}}>Analytics</span>
                        </a>
                    </li>
                    : "" : ""
                } */}

                {/* {seller ? seller.U_FMB_Handel_Perfil != '0' && seller.U_FMB_Handel_Perfil != 5 ? 
                    <li className="nav-item" onClick={() => { configReducer.history.goBoletin(); }}>
                        <a className="nav-link dropdown-menu-item" style={{ color: config.navBar.textColor }}>
                            <span className="dropdown-item dropdown-menu-item"  style={{color: config.navBar.textColor2}}>Ver correos del boletín</span>
                        </a>
                    </li>
                    : "" : ""
                } */}

                {/* {seller ? seller.U_FMB_Handel_Perfil != '0' && seller.U_FMB_Handel_Perfil != 5 && seller.U_FMB_Bonificaciones === "1" ?
                    <li className="nav-item" onClick={() => { configReducer.history.goPromocionales(); }}>
                        <a className="nav-link" style={{ color: config.navBar.textColor }}>
                            <span className="dropdown-item dropdown-menu-item" style={{color: config.navBar.textColor2}}>Bonificaciones</span>
                        </a>
                    </li>
                    : "" : ""
                } */}

                {config.modules.subirArchivoExcel && seller ? seller.U_FMB_Handel_Perfil != 5 && Object.entries(user).length !== 0 ?
                    <li className="nav-item" onClick={() => { configReducer.history.goSubirArchivo(); }}>
                        <a className="nav-link dropdown-menu-item" style={{ color: config.navBar.textColor }}>
                            <span className="dropdown-item dropdown-menu-item" style={{color: config.navBar.textColor2}}>Subir archivo OC</span>
                        </a>
                    </li>
                    : "" : ""
                }

                {seller ? seller.U_FMB_Handel_Perfil != 5 && Object.entries(user).length !== 0 ?
                    <li className="nav-item" onClick={() => { configReducer.history.goReports(); }}>
                        <a className="nav-link" style={{ color: config.navBar.textColor }}>
                            <span className="dropdown-item dropdown-menu-item" style={{color: config.navBar.textColor2}}>Mis reportes</span>
                        </a>
                    </li>
                    : "" : ""
                } 
                {/* {user.banners === "on" && */}
                {/* {user ? user.U_FMB_Handel_Admin == 1 ?
                    <li className="nav-item">
                        <a className="nav-link" style={{ color: config.navBar.textColor2 }}>
                            <span>
                                <Link to='/adminBanners' className="dropdown-item dropdown-menu-item" style={{color: config.navBar.textColor2}} >Adm. Banners 3</Link>
                            </span>
                        </a>
                    </li>
                    : "" : ""
                } */}
                {/* seller ? seller.U_FMB_AdmBlogNoticia == 1 ? */}
                {/* {seller ? seller.U_FMB_AdmBlogNoticia == 1 ?
                    <li className="nav-item">
                        <a className="nav-link dropdown-menu-item" style={{ color: config.navBar.textColor2 }}>
                            <span>
                                <Link to='/admiNewsBlog' className="dropdown-item dropdown-menu-item" style={{color: config.navBar.textColor2}} >Adm. Blog de noticias</Link>
                            </span>
                        </a>
                    </li>
                    : "" : ""
                } */}

                {/* {seller ? seller.U_FMB_Handel_Perfil === 5
                        ? 
                    <li className="nav-item" onClick={() => { configReducer.history.goAutorizaciones(); }}>
                        <a className="nav-link" style={{ color: config.navBar.textColor2 }}>
                            <span  style={{color: config.navBar.textColor2}}>Autorizaciones</span>
                        </a>
                    </li>
                        : "" : ""
                    } */}
                {/* {seller ? seller.U_FMB_Handel_Perfil != 5 ?
                    <li className="nav-item" onClick={() => { configReducer.history.goProfile(); }}>
                        <a className="nav-link" style={{ color: config.navBar.textColor }}>
                            <span  style={{color: config.navBar.textColor2}}>Mi Perfil</span>
                        </a>
                    </li>
                    : "" : ""
                } */}
                 <li className="nav-item" onClick={() => { this.logOut(); }}>
                    <a className="nav-link" style={{ color: config.navBar.textColor }}>
                        <span className="dropdown-item dropdown-menu-item" style={{color: config.navBar.textColor2}}>Cerrar Sesión</span>
                    </a>
                </li>
            </ul>
        )
    };


    renderSubFamiliaBody = (category) => {
        let divBody = document.getElementById('subMenuBody');
        let divFamilies = document.getElementById('Drop-Familia');
        // if(category.subFamily.length > 0){
            divFamilies.style.borderTopRightRadius = 0;
            divFamilies.style.borderBottomRightRadius = 0;

            divBody.style.display = "block";
            const listSubFamily = category.subFamily.map((subFamily) =>
                <div className="row">
                    <div className="col-12 text-Left" style={{background:"#242323", color:'white !important'}}> 
                        <a className="m-2" tabindex="-1" href="#"
                            style={{color:"white", fontWeight:"100"}} 
                            onClick={() => this.mostrarCategoria(category.Code, "menu2", subFamily.SubFamCode)}
                        >
                            {subFamily.SubFamName}
                        </a>
                    </div>
                    {/* <div class="dropdown-divider" ></div> */}
                </div>
            );
            ReactDOM.render(<span>{listSubFamily}</span>, divBody);
        // }else{
        //     divBody.style.display = "none";
        // }
    };



    dejanosMensaje = async () => {     
        setTimeout(() => {
            $('#dejanosMensajeModal').modal('show');
        }, 300);
    };

    renderSecondNavBar = () => {
        const { configReducer: { history,idCategoryFilter, idFamilyFilter,idMarkFilter,idOriginFilter, idTemperatureFilter}, sessionReducer: { user, role }, sessionReducer } = this.props;
        return (
            <div style={{ width: "100%", zIndex: 90, background: "transparent"}}>
                <div className="d-block d-lg-none" style={{ width: "100%", height: 45, background: "#000000" }}>
                    <nav className="navbar navbar-expand-lg navbar-two nav-dropdownMovil ">
                        <NavBarButton iconColor={config.navBar.iconColor2} icon={config.icons.user} ruta={this.iconUser(user.listNum)} style={{border:"2px solid #FFED00 !important", width:"100% !important" , fontsize: 25}} />  
                        <div className="collapse navbar-collapse" id="navbarSupportedContent1">
                            {sessionReducer.role === ROLES.PUBLIC ? this.renderPublicOptionMenu() : this.renderClientOptionMenu()}
                            <ul className="navbar-nav mr-auto">
                            
                                {/* <li className="nav-link nav-item text-white" style={{ cursor: "pointer", color: config.navBar.textCategories}} onClick={() => this.mostrarCategoria('2','I_Categoria')} >
                                    <span className="nav-link dropdown-toggle" href="#" id="navbarDropdown" data-toggle="dropdown" >Categoria</span> 
                                    <div className="dropdown-menu m-drop" aria-labelledby="navbarDropdown">
                                        {idCategoryFilter.map((category)=>{
                                            return (
                                                <div>
                                                    <li >
                                                        <a className="dropdown-item nav-item text-white a-movil  nav-link dropdown-toggle"  href="#" id="navbarDropdown2" data-toggle="dropdown" onClick={() => this.mostrarCategoria(category.Code,'menu2')}>{category.Name}</a>
                                                        <ul className="dropdown-menu ul-dropdown" aria-labelledby="navbarDropdown2">
                                                            {category.subFamily.map((family)=>{
                                                                return (
                                                                    <div>
                                                                        <li ><a className="li-dropdown" href="#" onClick={() => this.mostrarCategoria(category.Code, "menu2", family.SubFamCode)}>{ family.SubFamName}</a></li>
                                                                        <div class="dropdown-divider"></div>
                                                                    </div>
                                                                )
                                                            })}
                                                        </ul>
                                                    </li>
                                                    <div class="dropdown-divider"></div>
                                                </div>  
                                            )
                                        })}
                                    </div>
                                </li> */}
                                {/* <li className="nav-link nav-item text-white" style={{ cursor: "pointer", color: config.navBar.textCategories}} onClick={() => this.mostrarCategoria('3','I_Marca')}>
                                    <span className="nav-link dropdown-toggle" href="#" id="navbarDropdown" data-toggle="dropdown" >Marca</span> 
                                    <div className="dropdown-menu m-drop" aria-labelledby="navbarDropdown">
                                        {idMarkFilter.map((mark)=>{
                                            return (
                                                <div>
                                                    <li ><a className="dropdown-item nav-item text-white a-movil" href="#" onClick={() => this.mostrarCategoria(mark.Code,'menu3')}>{mark.Name}</a></li>
                                                    <div class="dropdown-divider"></div>
                                                </div>  
                                            )
                                        })}
                                    </div>
                                </li> */}
                                {/* comente esto por que segun no debe de ir en el responsivo */}
                                
                                {/* <li className="nav-link nav-item text-white " style={{ cursor: "pointer", color: config.navBar.textCategories}} >
                                    <span className="nav-link dropdown-toggle" href="#" id="navbarDropdown" data-toggle="dropdown" >Procedencia</span> 
                                    <div className="dropdown-menu m-drop" aria-labelledby="navbarDropdown">
                                        {idOriginFilter.map((origin)=>{
                                            return (
                                                <div>
                                                    <li ><a className="dropdown-item nav-item text-white a-movil" href="#" onClick={() => this.mostrarCategoria(origin.Code,'menu4')}>{origin.Name}</a></li>
                                                    <div class="dropdown-divider"></div>
                                                </div>  
                                            )
                                        })}
                                    </div>
                                </li> */}
                                {/* <li className="nav-link nav-item text-white" style={{cursor: "pointer", color: config.navBar.textCategories}} onClick={() => history.mostrarCategoria('5','I_Temperatura')}>
                                    <span className="nav-link dropdown-toggle" href="#" id="navbarDropdown" data-toggle="dropdown" >Temperatura</span> 
                                    <div className="dropdown-menu m-drop" aria-labell edby="navbarDropdown">
                                        {idTemperatureFilter.map((temperature)=>{
                                            return (
                                                <div>
                                                    <li ><a className="item nav-item text-white a-movil" href="#" onClick={() => this.mostrarCategoria(temperature.Code,'menu5')}>{temperature.Name}</a></li>
                                                    <div class="dropdown-divider"></div>
                                                </div>  
                                            )
                                        })}
                                    </div>
                                </li> */}
                                {/* informacion de la cuenta 117 responsive */}
                                {/* { role != 'PUBLIC' &&
                                <li className="nav-link nav-item text-white" style={{cursor: "pointer", color: config.navBar.textCategories}} onClick={() => this.openOrder()}>
                                    <span className="nav-link" href="#" id="navbarDropdown" data-toggle="dropdown" >Información de la cuenta</span> 
                                    
                                </li>
                                } */}
                                {/* <li className="nav-link nav-item " style={{cursor: "pointer", color: config.navBar.iconColor2}} onClick={this.dejanosMensaje}>COTIZA AQUÍ</li> */}
                                {/*
                                Quitar zonas de recompensas
                                {config.modules.redZone && 
                                    <li className="nav-link nav-item text-white" style={{ cursor: "pointer", color: config.navBar.iconColor2}} onClick={() => history.goRedZone()}>Zona de Recompensas</li>
                                }
                                */}
                                {/* {config.modules.redAliado && 
                                    <li className="nav-link nav-item text-white" style={{ cursor: "pointer", color: config.navBar.iconColor2}} onClick={() => history.goRedAliado()}>Aliados</li>
                                } */}
                                {/* {config.aboutUs.active &&
                                    <li className="nav-link nav-item text-white" style={{ cursor: "pointer" }} onClick={() => history.goAboutUs()}>
                                        <span> ¿Quiénes somos?</span>
                                    
                                    </li>} */}
                                {/* {config.contactUs.active &&
                                    <li className="nav-link nav-item text-white" style={{  cursor: "pointer" }} onClick={() => history.goContactUs()}>
                                        <span> Contáctanos </span>
                                    </li>} */}
                                {/* {config.questions.active &&
                                    <li className="nav-link" style={{ color: config.navBar.textColor, cursor: "pointer" }} onClick={() => history.goQuestions()}>
                                        <span> Preguntas frecuentes </span>
                                    </li>} */}
                                {/* {config.claim.active &&
                                    <li className="nav-link" style={{ color: config.navBar.textColor, cursor: "pointer" }} onClick={() => history.goClaim()}>
                                        <span>Contáctanos</span>
                                    </li>} */}
                                {/* {config.termPage.active &&
                                    <li className="nav-link" style={{ color: config.navBar.textColor, cursor: "pointer" }} onClick={() => history.goPolitics()}>
                                        <span> Términos de uso </span>
                                    </li>} */}
                                {/*
                                    <li className="nav-link nav-item text-white" style={{ color: config.navBar.textColor, cursor: "pointer" }} onClick={() => { this.logOut(); }}>
                                        <span>Cerrar Sesión</span>
                                    </li>
                                    */}
                            </ul>
                        </div>
                    </nav>
                </div>
                <div className="d-12 d-none d-lg-flex" style={{ width: "100%", background: config.navBar.backgroundColor }}>
                    <nav className="navbar navbar-expand-md navbar-light navbar-two" style={{ width: "100%", backgroundColor: "black", color: "white", height:"2.3rem" }}>
                        <div className="d-none d-lg-block col-md-12">
                            <ul className="navbar-nav justify-content-md-center" style={{height:"33px"}}>
                                {/* <li className="nav-link col-auto text-navbar mt-2 " style={{ color: config.navBar.textCategories,cursor: "pointer"}} */}
                                {/* /onClick={() => this.mostrarCategoria('1','Familia')}>*/}
                                    {/* <img src={config.NavarIconos.iconOne} className="Img-fluid"></img>
                                    <a className= "dropdown-toggle" data-toggle="dropdown">
                                        <span>FAMILIA</span>
                                    </a>
                                    <ul className="dropdown-menu ul-dropdown" style={{ border: "4px solid #ffed00 !important"}}>
                                        <li><span className="li-dropdown">Subcategoria 1</span></li>
                                            <li className="dropdown-submenu" style={{ padding: "0 0 0 0" }} >
                                                <span className="li-dropdown">Subcategoria 6</span>
                                                    <ul className="dropdown-menu">
                                                     <li><span className="li-dropdown">Subcategoria 1</span></li>
                                                </ul>
                                            </li>
                                            {idFamilyFilter.map((family)=>{
                                                    return (
                                                        <div>
                                                            <li ><a className="li-dropdown" href="#" onClick={() => this.mostrarCategoria(family.Code,'menu1')}>{family.Name}</a></li>
                                                            <div class="dropdown-divider"></div>
                                                        </div>
                                                    )
                                            })}
                                    </ul>
                                </li> */}
                                <li className="nav-link col-auto text-navbar" style={{ color: config.navBar.textCategories, cursor: "pointer"}} >
                                    <a className= "dropdown-toggle" data-toggle="dropdown">
                                        <span style={{ color:"white", fontSize: "15px"}} >CATEGORIA</span>
                                    </a>
                                    {/* Region Body categories */}
                                    <div id= 'dropCaract-Familia' className="dropdown-menu" style={{width: "2561px" ,maxHeight: "auto", minHeight:"20vh", border: "none", left: "0px", top:"110px", position:"fixed"}} >
                                        <div class="col-12" style={{display:"flex", maxHeight: "43vh", minHeight:"20vh", padding: 0, paddingTop:5}}>
                                            <div id ="Drop-Familia"  className='' style={{maxWidth:"200px"}}>
                                                {idCategoryFilter.map((category)=>{
                                                    return (
                                                        <div className="selec">
                                                            <div class="selec p-2">
                                                                <a style = {{textAlign: "center !important", textDecoration: "none", color:"white"}}
                                                                    className="li-dropdown selec" tabindex="-1" href="#" 
                                                                    onClick={() => this.mostrarCategoria(category.Code,'menu2')}
                                                                    onMouseOver = {() => this.renderSubFamiliaBody(category)}
                                                                >{category.Name}</a>
                                                            </div>
                                                            {/* <div class="dropdown-divider" ></div> */}
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                            <div id="subMenuBody" className='col-8 subMenuBody' style={{background:"#242323", overflowY: "scroll", paddingTop:5}}>
                                                <div>
                                                    <div style={{background:"#242323", color:'white !important'}}> 
                                                        {/* <a className="li-dropdown m-2" tabindex="-1" href="#" 
                                                            onClick={() => this.mostrarCategoria(category.Code, "menu2", subFamily.SubFamCode)}
                                                        >
                                                            {subFamily.SubFamName}
                                                        </a> */}
                                                    </div>
                                                        {/* <div class="dropdown-divider" ></div> */}
                                                </div>
                                            </div> 
                                        </div>
                                    </div>
                                    {/* Fin region */}
                                </li>



                                <li className="nav-link col-auto text-navbar" style={{ color: config.navBar.textCategories, cursor: "pointer"}} /*onClick={() => this.mostrarCategoria('3','Procedencia')}*/>
                                    {/* <img src={config.NavarIconos.iconTwo} className="Img-fluid" ></img> */}
                                    <a className="dropdown-toggle"data-toggle="dropdown">
                                        <span style={{ color:"white", fontSize: "15px"}}>MARCA</span>
                                    </a>
                                    <ul className="dropdown-menu ul-dropdown">
                                        {idMarkFilter.map((temperature)=>{
                                            return (
                                                <div className="m-2">
                                                    <li ><a className="li-dropdown" href="#" onClick={() => this.mostrarCategoria(temperature.Code,'menu3')}>{temperature.Name}</a></li>
                                                    {/* <div class="dropdown-divider"></div> */}
                                                </div>
                                            )
                                        })}
                                    </ul>
                                </li>

                                {/* <li className="nav-link col-auto text-navbar mt-2" style={{ color: config.navBar.textCategories, cursor: "pointer"}} 
                                onClick={() => this.mostrarCategoria('5','Temperatura')}> 
                                <img src={config.NavarIconos.iconOne} className="Img-fluid"></img>
                                   <a className="dropdown-toggle"data-toggle="dropdown">
                                         <span>PROCEDENCIA</span>
                                    </a>
                                    <ul className="dropdown-menu ul-dropdown">
                                        {idOriginFilter.map((origin)=>{
                                                    return (
                                                        <div>
                                                            <li ><a className="li-dropdown" href="#" onClick={() => this.mostrarCategoria(origin.Code,'menu4')}>{origin.Name}</a></li>
                                                            <div class="dropdown-divider"></div>
                                                        </div>
                                                    )
                                            })}
                                    </ul>
                                </li> */}
                                <li className="nav-link col-auto text-navbar" style={{ color: config.navBar.textCategories, cursor: "pointer"}} /* onClick={() => this.mostrarCategoria('5','Temperatura')}*/>
                                    {/* <img src={config.NavarIconos.iconOne} className="Img-fluid"></img> */}
                                    <span className="dropdown-toggle" data-toggle="dropdown" style={{ color: "white", fontSize: "15px" }}>TEMPERATURA</span> 

                                    <ul className="dropdown-menu ul-dropdown">
                                        {idTemperatureFilter.map((temperature)=>{
                                            return (
                                                <div>
                                                    <li ><a className="li-dropdown" href="#" onClick={() => this.mostrarCategoria(temperature.Code,'menu5')}>{temperature.Name}</a></li>
                                                    <div class="dropdown-divider"></div>
                                                </div>
                                            )
                                        })}
                                    </ul>
                                </li>
                                {/* INFORMACION DE LA CUENTA  */}
                                { //role != 'PUBLIC' &&
                                // <li className="nav-link col-auto text-navbar mt-2 " style={{ color: config.navBar.textCategories, cursor: "pointer"}} onClick={() => this.openOrder()} >
                                //     <span  data-toggle="dropdown">
                                //         <img src={config.NavarIconos.iconFour} height='35px' className="Img-fluid" onClick={() => this.openOrder()}></img>   
                                //     </span>
                                // </li>
                                // <li className="nav-link text-center col-2 imgCaterogies" style={{ color: config.navBar.textCategories, cursor: "pointer", paddingTop:"-8px"}} onClick={() => this.openOrder()}>
                                //     <span  data-toggle="dropdown">
                                //         <img src={config.NavarIconos.iconFour} height='28px' className="Img-fluid" onClick={() => this.openOrder()} ></img>   
                                //     </span>
                                // </li>
                                }
                            </ul>
                        </div>
                    </nav>
                </div>
            </div>
        );
    };

    mostrarCategoria = async (valor,seccion, subCategory = null) => {
        const {setIdCategory, setLocation,itemsReducer: {searchByCategories},setNextPage} = this.props;
        await setIdCategory(valor);
        await setNextPage(0); 
        await setLocation('menuCategories');
        searchByCategories(valor,0,seccion, subCategory);
    };
    // mostrarCategoria = (valor,seccion) => {
    //     const {setIdCategory, setLocation,itemsReducer: {searchByCategories},setNextPage} = this.props;
    //     setIdCategory(valor);
    //     setNextPage(0); 
    //     setLocation('menuCategories');
    //     searchBy(valor,0,seccion);
    // };
    //117 funcion para la informacion de la cuenta
    openOrder = async () => {
        const {enableSpinner, notificationReducer: {showAlert} } = this.props;
        const { user } = this.state
        enableSpinner(true);
        
        if (user !== null) {
            $('#dataProfiel').modal('show');   
        }else{
            showAlert({type: 'warning', message: "No hay un cliente seleccionado"})
        }
             
        enableSpinner(false);
        return;
    };

    handleOutletZone = async ()=>{
        const { configReducer: { history }} = this.props;
        const {itemsReducer,setIdCategory,setLocation} = this.props;
        setIdCategory(null);
        setLocation('outletView');
        await itemsReducer.searchByKey(0, 'outletView');
    }
    handleWhiteZone = async ()=>{
        const { configReducer: { history }} = this.props;
        const {itemsReducer,setIdCategory,setLocation} = this.props;
        setIdCategory(null);
        setLocation('whiteView');
        await itemsReducer.searchByKey(0, 'whiteView');
    }
    handleRedPolarZone = async ()=>{
        const { configReducer: { history }} = this.props;
        const {itemsReducer,setIdCategory,setLocation} = this.props;
        setIdCategory(null);
        setLocation('redView');
        await itemsReducer.searchByKey(0,'redView');
    }

    render() {
        const { sessionReducer: { user }, sessionReducer } = this.props;
        const { order } = this.state;
        return (
            <div>
                <MenuCategories />
                <LoginRegisterModal />
                <LoginModal />
                <DejanosMensajeModal
                    Usuario={user}
                    datos = {sessionReducer.role}
                ></DejanosMensajeModal>
                <ProfieldModel order={order} />
                {this.searchModal()}
                <div className="fixed-top" style={{ background: config.navBar.backgroundColor, zIndex: 200}}>
                    {this.renderFirstNavBar()}
                    {this.renderSecondNavBar()}
                </div>
            </div>
        );
    }
}

const mapStateToProps = store => {
    return {
        itemsReducer: store.ItemsReducer,
        sessionReducer: store.SessionReducer,
        configReducer: store.ConfigReducer,
        shoppingCartReducer: store.ShoppingCartReducer,
        notificationReducer: store.NotificationReducer
    };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value }),
        setItemsSearch: value => dispatch({ type: DISPATCH_ID.ITEMS_SET_ITEMS, value }),
        setItemsFilterSearch: value => dispatch({ type: DISPATCH_ID.ITEMS_SAVE_ITEMS_FILTER, value }),

        setRole: value => dispatch({ type: DISPATCH_ID.SESSION_SET_ROLE, value }),
        addNotificationReference: value => dispatch({ type: DISPATCH_ID.NOTIFICATION_SET_ALERT_REFERENCE, value }),
        setBusiness: value => dispatch({ type: DISPATCH_ID.SESSION_SET_BUSINESS_ID, value }),
        setToken: value => dispatch({ type: DISPATCH_ID.SESSION_SET_TOKEN, value }),
        setUser: value => dispatch({ type: DISPATCH_ID.SESSION_SET_USER, value }),
        setRememberUser: value => dispatch({ type: DISPATCH_ID.SESSION_SET_REMEMBER_USER, value }),
        setLogOutReference: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_LOG_OUT_REFERENCE, value }),
        setIdCategory: value => dispatch({type: DISPATCH_ID.ITEMS_SET_IDCATEGORY, value}),
        setNextPage:  value => dispatch({type: DISPATCH_ID.ITEMS_SET_NEXTPAGE, value}),
        setLocation:  value => dispatch({type: DISPATCH_ID.ITEMS_SET_LOCATION, value}),
        setItemsAutoComplete: value => dispatch({type: DISPATCH_ID.ITEMS_SET_AUTO_COMPLETE, value}),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NavBar);
